import { create } from 'zustand'
import { persist } from 'zustand/middleware'

// Base recommendations per audience
const BASE_STAGE_RECOMMENDATIONS = {
    acquisition: { min: 3, max: 5 },
    reengagement: { min: 2, max: 4 },
    retargeting: { min: 2, max: 3 },
    retention: { min: 1, max: 3 }
}

const useAdsSelectionStore = create(
    persist(
        (set, get) => ({
            // Currently selected audience for editing (persisted)
            selectedAudience: null,
            selectedStage: null,
            
            // Set the currently selected audience/stage
            setSelectedAudience: (audience, stage) => {
                set({
                    selectedAudience: audience,
                    selectedStage: stage
                })
            },
            
            // Clear selection
            clearSelection: () => {
                set({
                    selectedAudience: null,
                    selectedStage: null
                })
            },
            
            // Get recommendation for currently selected audience
            getCurrentRecommendation: () => {
                const { selectedAudience, selectedStage } = get()
                
                if (!selectedAudience || !selectedStage) {
                    return null
                }
                
                const stageRec = BASE_STAGE_RECOMMENDATIONS[selectedStage.id]
                if (!stageRec) return null
                
                return {
                    stage: selectedStage.id,
                    stageName: selectedStage.name,
                    audienceName: selectedAudience.name,
                    min: stageRec.min,
                    max: stageRec.max,
                    stageColor: selectedStage.color
                }
            },
            
            // Check if current selection needs warning based on creative count
            getWarningForCurrent: (currentCreativeCount) => {
                const { selectedAudience, selectedStage } = get()
                
                if (!selectedAudience || !selectedStage) {
                    return null
                }
                
                const stageRec = BASE_STAGE_RECOMMENDATIONS[selectedStage.id]
                if (!stageRec) return null
                
                const isOutOfRange = currentCreativeCount < stageRec.min || currentCreativeCount > stageRec.max
                
                if (!isOutOfRange) return null
                
                return {
                    stage: selectedStage.id,
                    stageName: selectedStage.name,
                    audienceName: selectedAudience.name,
                    current: currentCreativeCount,
                    min: stageRec.min,
                    max: stageRec.max,
                    stageColor: selectedStage.color
                }
            }
        }),
        {
            name: 'ads-selection-store',
            partialize: (state) => ({
                selectedAudience: state.selectedAudience,
                selectedStage: state.selectedStage
            })
        }
    )
)

export default useAdsSelectionStore